import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[(_vm.feature)?_c(VIcon,_vm._b({class:_vm.feature.class,attrs:{"color":_vm.useColor ? _vm.feature.color : ''}},'v-icon',_vm.$attrs,false),[_vm._v(_vm._s(_vm.feature.icon))]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }